import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// local components
import DiscountDetails from './DiscountDetails'
import SelectDays from './SelectDays'
import ProductInfoLink from './ProductInfoLink'
import DayPassProductInfo from './DayPassProductInfo'
import VolumeDiscountHint from './VolumeDiscountHint'

// helpers
import { centsToDollars } from 'lib/helpers/money'

const DayPassProduct = props => {
  const {
    product,
    camper,
    session,
    camperSession,
    plan,
    cartProduct,
    dayPassPriceCents,
    volumeDiscountPriceCents,
    account
  } = props

  const { accountDiscount } = cartProduct
  const { discountCents, discountCategory } = accountDiscount || {}
  const { variablePriceCents, description } = product || {}

  const modalId = `product-info-${camper.id}-${session.id}-day-pass`
  const modalTitle = `${product.description} - ${centsToDollars(dayPassPriceCents)}/day`

  return (
    <Box display='flex' my={1}>
      <Box flexShrink={0} alignItems='center'>
        <SelectDays
          camper={camper}
          plan={plan}
          session={session}
          camperSession={camperSession}
          product={product}
          cartProduct={cartProduct}
          productType={'day-pass'}
        />
      </Box>
      <Box display='flex' alignItems='center'>
        <Typography ml={1} component='span' variant='body1'>
          {description} – {centsToDollars(dayPassPriceCents)}/day
          {discountCents > 0 && (
            <DiscountDetails>
              ({centsToDollars(variablePriceCents)} -{' '}
              {centsToDollars(discountCents)} {discountCategory} discount)
            </DiscountDetails>
          )}
        </Typography>

        {/* modal */}
        <ProductInfoLink modalId={modalId} />
        <DayPassProductInfo
          modalId={modalId}
          modalTitle={modalTitle}
          product={product}
          session={session}
          dayPassPriceCents={dayPassPriceCents}
          volumeDiscountPriceCents={volumeDiscountPriceCents}
          addDaysPriceCents={dayPassPriceCents}
        />
      </Box>
      {
        <VolumeDiscountHint
          camperSession={camperSession}
          cartProduct={cartProduct}
          account={account}
        />
      }
    </Box>
  )
}

export default DayPassProduct
